import { isQA } from '../../constants/apiEnvironments';
import { getQueryParam } from '../../routing/getQueryParam';
export const isMicrosoftOAuthEnabled = () => isQA && Boolean(getQueryParam('microsoft_oauth_enabled'));